import React from "react";
import CustomDialog from "../Utils/Dialogs/CustomDialog";
import Form from "react-bootstrap/Form";
import Label from "../Utils/FormInputs/Label";
import {CustomInput} from "../Inventory/CustomInput";
import axios from "axios";
import {config} from "../../Helpers/env";
import {errorMessages} from "../../Helpers/ErrorMessages";

export function EditExchangeRate({openDialog, setOpenDialog, isSubmitted, setIsSubmitted, actions, currencyDetails}) {
    const [submitted, setSubmitted] = React.useState(false)
    const [currency, setCurrency] = React.useState({value: '', label: '', name: ''})
    const [state, setState] = React.useState({exchange_rate: 0, date_as_of: ''})
    const formRef = React.useRef()

    console.log('details', currencyDetails.date_as_of)

    React.useEffect(() => {
        if (!currencyDetails?.id) {
            return
        }
        setCurrency({
            value: currencyDetails.currency_symbol,
            label: `${currencyDetails.currency_symbol} ${currencyDetails.currency_name}`
        })
        const ex_rate = Math.pow(Number(currencyDetails.exchange_rate), -1)
        setState({exchange_rate: ex_rate, date_as_of: currencyDetails.date_as_of})

    }, [currencyDetails.id])


    const handleSubmit = (event) => {
        event.preventDefault()
        setSubmitted(true)
        const form = new FormData(event.currentTarget)
        const fieldValues = Object.fromEntries(form.entries())
        const ex_rate = fieldValues?.exchange_rate ? Math.pow(Number(fieldValues?.exchange_rate), -1) : 1;
        if (fieldValues?.exchange_rate) {
            setIsSubmitted('pending')
            axios.post(`${config.smsUrl}/currency/edit_exchange_rate`, {
                rate_id: currencyDetails.id,
                exchange_rate: ex_rate
            }).then(() => {
                actions.snackbarActions.snackSuccess('Exchange rate edited successfully');
                setIsSubmitted('resolved');
                setSubmitted(false);
                setOpenDialog(false);
            }).catch(err => {
                errorMessages(err, null, actions);
                setIsSubmitted('rejected');
            });
        }
    }


    const isPending = isSubmitted === 'pending'

    return (
        <CustomDialog handleClose={() => {
            setOpenDialog(false)
        }} open={openDialog} title={`Edit Exchange Rate`}
                      buttons={null}>
            <form ref={formRef} autoComplete='off' onSubmit={handleSubmit}>
                <Form.Group>
                    <Label name='Currency' htmlFor="currency" type/>
                    <CustomInput submitted={submitted} name='currency' type='text' inputValue={currency.label}
                                 disabled/>
                </Form.Group>
                <Form.Group>
                    <Label name="As of date" htmlFor="date_as_of" type/>
                    <CustomInput submitted={submitted} name='date_as_of' type='date' inputValue={state.date_as_of}
                                 isRequired disabled/>
                </Form.Group>
                <Form.Group>
                    <Label name="Exchange rate" htmlFor="exchange_rate" type/>
                    <CustomInput submitted={submitted} name='exchange_rate' type='number'
                                 inputValue={state.exchange_rate}
                                 isRequired/>
                </Form.Group>
                <button type='submit' disabled={isPending}
                        className='btn btn-sm sms-info-btn small-btn'>{isPending ? 'Saving...' : 'Save'}</button>
            </form>
        </CustomDialog>
    )
}